/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.data
 * @name     csm.books.data.BooksData.type:AccountInfo
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Account information for selection of account from an account list. Mirrors
 * `csm.booksdb.data.AccountInfo` on server.
 *******************************************************************************/
/* @ngInject */ export function accountInfoConfig(TypeFactoryProvider) {
  TypeFactoryProvider.addType({
    name: 'Data.books.AccountInfo',
    $type: 'csm.booksdb.data.AccountInfo, CSMBooksDBCS',
    prototype: {
      accountID: 0, // Account ID.
      organizationID: 0, // Organization ID.
      accountNumber: null, // Account Number.
      accountName: null, // Account Name.
      accountClass: 0, // Account Class.
      subClass: 0, // Account SubClass.
      side: 0, // Account Type Side (Dr/Cr).
      type: null, // Account Type.
      requireClass: false, // Class required for journal item flag.
      classType: null, // Required class type.
      classID: null, // Class ID.
      currentBalance: 0, // Current account balance.
      payeeID: null // SchoolPay's PayeeID for an AccountID.
    }
  });
};
